import React from "react";
import useWindowDimensions from "../get-diemensions/UseWindowDiemensions";
import { MenuDisplayHeader } from "../components";
import { useNavigate } from "react-router-dom";

const SuperAdmin = () => {
  const { width, height } = useWindowDimensions();
  const navigate = useNavigate();
  return (
    <div
      style={{
        width: width,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <MenuDisplayHeader
        selected={"practioners"}
        width={width}
        // onAboutClick={() => navigate("/")}
        // onPharmaciesClick={() => navigate("/pharmacies")}
        // onLegalityClick={() => navigate("/legality")}
      />
      SuperAdmin
    </div>
  );
};

export default SuperAdmin;
